import IconPdf from '@fortuneo/ui-icons/specials/IconPdf'
import clsx from 'clsx'
import React, { type FC, type PropsWithChildren } from 'react'

import { EnhancedLink } from './enhanced-components/enhanced-components'
import { ENHANCED_COMPONENT_TYPE } from './enhanced-components/types'

type HyperlinkProps = {
  href: string
}

export const Hyperlink: FC<PropsWithChildren<HyperlinkProps>> = ({
  href,
  children,
  ...props
}) => {
  const isPdf = String(href).endsWith('.pdf')

  return (
    <EnhancedLink
      data-type={ENHANCED_COMPONENT_TYPE.HYPERLINK}
      href={href}
      icon={isPdf ? <IconPdf className="!fill-theme-info-main" /> : undefined}
      iconPosition={isPdf ? 'before' : 'none'}
      className={clsx(
        'group-[.is-blue]/section-template:!text-text-inverse',
        'group-[.is-blue]/component:!text-text-inverse',
        'group-[.is-blue]/section-template:hover:!text-theme-info-accent1',
        'group-[.is-blue]/component:hover:!text-theme-info-accent1'
      )}
      {...props}
    >
      {children}
    </EnhancedLink>
  )
}
